define(["mw-log/Log", "./Sender"], function (Log, Sender) {
  "use strict";

  var _exports = {};
  // Copyright 2022-2023 The MathWorks, Inc.

  /**
   * Defines class that drops events rather than sending them
   * @private
   */
  class StubSender extends Sender {
    constructor(properties) {
      super();
    }
    stop() {
      // Nothing to do
    }
    sendEvent(eventType, event) {
      Log.info('StubSender dropping event');
    }
  }
  _exports.default = StubSender;
  return _exports.default;
});
//# sourceMappingURL=StubSender.js.map
